import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';
import { BulkDeleteOrderAdapter } from '../adapters/bulkDeleteOrderAdapter';

/**
 * 発注の削除を行うユースケース
 */
export class BulkDeleteOrderUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注の削除を適用する
   * @param orderIds - 削除する発注ID
   */
  public async Execute(orderIds: string[]): Promise<INetworkResult<string[], Error>> {
    try {
      const response = await this.repository.bulkDelete(BulkDeleteOrderAdapter.adaptForRequest(orderIds));
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: [],
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
